import { useEffect, useState, RefObject } from "react";

export function useIframeSectionSelection(
  iframeRef: RefObject<HTMLIFrameElement>,
  iframeOrigin: string
): [string | null, React.Dispatch<React.SetStateAction<string | null>>] {
  const [selectedSection, setSelectedSection] = useState<string | null>(null);

  useEffect(() => {
    function onMessage(e: MessageEvent) {
      if (e.origin !== iframeOrigin) return;
      const msg = e.data || {};

      if (msg.type === "sectionClicked") {
        setSelectedSection(msg.sectionId);
      }
    }

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [iframeOrigin]);

  useEffect(() => {
    if (!iframeRef.current || selectedSection == null) return;

    const targetWindow = iframeRef.current.contentWindow;
    if (targetWindow) {
      targetWindow.postMessage(
        { type: "highlight", sectionId: selectedSection },
        iframeOrigin
      );
    }
  }, [iframeRef, selectedSection, iframeOrigin]);

  return [selectedSection, setSelectedSection];
}
